import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cell-katex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_katex = _resolveDirective("katex")!

  return (_openBlock(), _createElementBlock("div", {
    class: "cell-container",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.cellClass)
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
        [_directive_katex, _ctx.expression]
      ])
    ], 2)
  ]))
}